module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'subActions'
	],

	formMapping: {
		cols: [
			[
				{ type: 'buttons', buttons: [
					{ buttonType: 'showInsert', context: 'route', mode: 'rootLang', text: 'Neuer Sprachknoten', privilegeCode: "usage:languages:create" },
					{ buttonType: 'showInsert', context: 'route', mode: 'root', text: 'Neue Hauptseite', privilegeCode: "cms_routes:create" }
				] }
			]
		]
	}
};
